"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var ImageIcon = function ImageIcon(_ref) {
  var size = _ref.size,
    src = _ref.src,
    alt = _ref.alt;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    src: src,
    alt: alt,
    width: _styles.iconSize[size],
    height: _styles.iconSize[size]
  });
};
exports.ImageIcon = ImageIcon;
ImageIcon.defaultProps = {
  size: 's'
};